
export const baseUrl = 'https://zerox-cloud-service.onrender.com'
// export const baseUrl = 'http://localhost:4000'


export const loginUrl = baseUrl + "/auth/supabase/verify-otp";

export const otpRequestUrl = baseUrl + "/auth/supabase/login";
// Vendors
export const vendorsUrl = baseUrl + "/user";

export const statusUrl = baseUrl + '/statuses'

export const citiesUrl = baseUrl + '/cities'; 

export const statesUrl = baseUrl + '/states'; 

export const deliverySlotsUrl = baseUrl + "/delivery-slots";

export const paymentMethodsUrl = baseUrl + '/payment-methods'

export const storesUrl = baseUrl + '/stores'
export const storeStatusUrl = storesUrl + 'status'

export const locationsUrl = baseUrl + '/locations';
export const storecostUrl = baseUrl + '/store-costs'
export const printColorsUrl = baseUrl + "/print-colors";
export const storeMetaUrl = baseUrl + '/store-meta';

// Services
export const servicesUrl = baseUrl + '/services';
export const getServiceByIdUrl = (id) => `${baseUrl}/services/${id}`;
export const updateServiceUrl = (id) => `${baseUrl}/services/${id}`;
export const deleteServiceUrl = (id) => `${baseUrl}/services/${id}`;
export const SECRET_KEY = "ARBAZ@9898"

// Service Types
export const serviceTypesUrl = baseUrl + '/service-types';            // GET all + POST
export const getServiceTypeByNameUrl = baseUrl + '/service-types/name'; // GET by name
export const getServiceTypeByIdUrl = (id) => `${baseUrl}/service-types/${id}`; // GET by id
export const updateServiceTypeUrl = (id) => `${baseUrl}/service-types/${id}`; // PATCH
export const deleteServiceTypeUrl = (id) => `${baseUrl}/service-types/${id}`; // DELETE
// Users
export const usersUrl = baseUrl + '/user';               // GET all + POST create
export const searchUserUrl = usersUrl + '/search';       // GET by email
export const getUserByIdUrl = (cognitoId) => `${usersUrl}/${cognitoId}`;   // GET by ID
export const updateUserUrl = (cognitoId) => `${usersUrl}/${cognitoId}`;    // PUT update
export const deleteUserUrl = (email) => `${usersUrl}/${email}`;            // DELETE by email

// Service Configs
export const serviceConfigsUrl = baseUrl + '/service-configs';
export const createServiceConfigUrl = baseUrl + '/service-configs'; // POST
export const getAllServiceConfigsUrl = baseUrl + '/service-configs'; // GET
export const getServiceConfigByIdUrl = (id) => `${baseUrl}/service-configs/${id}`; // GET
export const updateServiceConfigUrl = (id) => `${baseUrl}/service-configs/${id}`; // PATCH
export const deleteServiceConfigUrl = (id) => `${baseUrl}/service-configs/${id}`; // DELETE

export const getServiceConfigsByServiceIdUrl = (serviceId) => `${baseUrl}/service-configs/service/${serviceId}`; // GET
export const getServiceConfigsByServiceTypeIdUrl = (serviceTypeId) => `${baseUrl}/service-configs/service-type/${serviceTypeId}`; // GET
export const getServiceConfigsByStoreIdUrl = (storeId) => `${baseUrl}/service-configs/store/${storeId}`; // GET
export const getDefaultServiceConfigUrl = baseUrl + '/service-configs/default'; // GET

export default baseUrl;


export const vendorsNameUrl = baseUrl + '/vendors?is_all=true'

export const citiesNameUrl = baseUrl + '/cities?is_all=true'

export const locationsNameUrl = baseUrl + '/locations?is_all=true'

// Customers
export const customersUrl = baseUrl + '/customers';

// Queries
export const customerQueriesUrl = baseUrl + '/customer-queries';
export const customerQueryByIdUrl = (id) => `${baseUrl}/customer-queries/${id}`;
export const customerQueryStatusUrl = (id,status) => `${baseUrl}/customer-queries/${id}/status/${status}`;

// Business Enquiries
export const businessEnquiriesUrl = baseUrl + '/business-enquiries';
export const businessEnquiryStatusUrl = (id) => `${baseUrl}/business-enquiries/${id}/status`;



